import { render, staticRenderFns } from "./AGBAgreementModal.vue?vue&type=template&id=a472e05c&"
import script from "./AGBAgreementModal.vue?vue&type=script&lang=js&"
export * from "./AGBAgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./AGBAgreementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports